export const drmtDailyFilterPayload = {
  divisions: [],
  originCountries: [],
  destinationCountries: [],
  filters: {
    carrierScac: [],
    carrierName: [],
    serviceScac: [],
    tariffNumber: [],
    tariffId: [],
    orgHub: [],
    originZone: [],
    originZoneDesc: [],
    originZoneShortDesc: [],
    originCity: [],
    originState: [],
    originCountry: [],
    destHub: [],
    destinationZone: [],
    destinationZoneDesc: [],
    destinationZoneShortDesc: [],
    destinationCity: [],
    destinationState: [],
    destinationCountry: [],
    region: [],
    carrierManager: [],
    miles: { params: [], operator: "" },
    orderType: [],
    primaryCustomers: [],
    preAwarded: [],
    equipmentType: [],
    laneDescription: [],
    // Newly added is this really need?
    // chargeId: [],
    // rangeCode: [],
    // rangeToUnits: [],
    // qtyBucketType: [],
    // qtyStartDate: { date: [], operator: "", },
    // qtyEndDate: { date: [], operator: "", },
    // pctBucketType: [],
    // pctStartDate: { date: [], operator: "", },
    // pctEndDate: { date: [], operator: "", },
    //
    lineHaulChargeType: [],
    rate: { params: [], operator: "" },
    btfRate: { params: [], operator: "" },
    effectiveDate: { date: [], operator: "" },
    expirationDate: { date: [], operator: "" },
    awardBackup: [],
    bucketType: [],
    qtyActiveFlag: [],
    minShipmentsAllocated: { params: [], operator: "" },
    maxShipmentsAllocated: { params: [], operator: "" },

    percentageActiveFlag: [],
    pctAward: { params: [], operator: "" },

    modeOfTransport: [],
    minCarrierAllocationPercentage: { params: [], operator: "", },
    maxCarrierAllocationPercentage: { params: [], operator: "", },
    status: [],
    changeComment: [],
    defaultError: [],
    qtyBucketType: [],
    pctBucketType: [],
    userId: [],
    createdDate: { date: [], operator: "" },
    updatedDate: { date: [], operator: "" },
  },
};
